import React from 'react';
import { Card, CardContent, Badge } from '@/components/ui';

export interface EquipmentItem {
  id: string;
  name: string;
  model: string;
  status: 'in_use' | 'available';
  imageUrl?: string;
}

interface EquipmentStatusProps {
  items?: EquipmentItem[];
  isLoading?: boolean;
}

export function EquipmentStatus({ items, isLoading }: EquipmentStatusProps) {
  const defaultItems: EquipmentItem[] = [
    { id: '1', name: 'Máy đào mini', model: 'KOMATSU PC30', status: 'in_use', imageUrl: 'https://cdn-icons-png.flaticon.com/512/2991/2991469.png' },
    { id: '2', name: 'Máy trộn bê tông', model: 'HONG HA 250L', status: 'in_use', imageUrl: 'https://cdn-icons-png.flaticon.com/512/1039/1039712.png' },
    { id: '3', name: 'Máy cắt cỏ', model: 'STIHL FS 250', status: 'in_use', imageUrl: 'https://cdn-icons-png.flaticon.com/512/2830/2830172.png' },
    { id: '4', name: 'Xe rùa', model: 'Wheel Barrow', status: 'available', imageUrl: 'https://cdn-icons-png.flaticon.com/512/3014/3014166.png' },
  ];

  const displayItems = items || defaultItems;

  return (
    <Card className="border-none shadow-sm h-full">
      <CardContent className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-sm font-bold text-slate-800">Thiết bị đang sử dụng</h3>
          <button className="text-[10px] font-bold text-emerald-600 hover:underline">Xem chi tiết</button>
        </div>

        <div className="space-y-5">
          {displayItems.map((item) => (
            <div key={item.id} className="flex justify-between items-center">
              <div className="flex gap-3">
                <div className="w-10 h-10 rounded-lg bg-slate-50 flex items-center justify-center shrink-0 border border-slate-100 p-1.5">
                  <img src={item.imageUrl} alt={item.name} className="w-full h-full object-contain opacity-80" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-bold text-slate-700 truncate leading-tight mb-1">{item.name}</p>
                  <p className="text-[10px] font-medium text-slate-400 italic">{item.model}</p>
                </div>
              </div>
              <Badge 
                variant="outline" 
                className={`sm:text-sm text-xs font-normal px-2 py-0.5 rounded-md border ${
                  item.status === 'in_use' 
                    ? 'bg-emerald-50 text-emerald-600 border-emerald-100' 
                    : 'bg-emerald-50 text-emerald-600 border-emerald-100'
                }`}
              >
                {item.status === 'in_use' ? 'Đang sử dụng' : 'Sẵn sàng'}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
